import { ISO3166Alpha3 } from '../../indigofair/iso3166/ISO3166Alpha3';
import { SettingConst } from '../../types';

/**
 * The list of countries where marketing SMS are allowed.
 */
export const MARKETING_SMS_ELIGIBLE_COUNTRIES =
  'MARKETING_SMS_ELIGIBLE_COUNTRIES' as SettingConst<
    'MARKETING_SMS_ELIGIBLE_COUNTRIES',
    Array<keyof typeof ISO3166Alpha3>,
    'RETAILER' | 'VISITOR_WEB' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'MAKER'
  >;
